var _dec, _dec2, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
import { BeanBase } from 'zova';
import { Bean } from 'zova-module-a-bean';
import { ServiceComposer } from '../service/composer.js';
export let BeanBehavior = (_dec = Bean(), _dec2 = __z_BeanInfo({
  module: "a-behavior"
}), _dec(_class = _dec2(_class = class BeanBehavior extends BeanBase {
  async createComposer(behaviors) {
    return await this.bean._newBean(ServiceComposer, true, behaviors);
  }
}) || _class) || _class);